import { useEffect } from "react";
import { LOGO_LIGHT_DATA } from "./assets.js";

const ShareCardTabata = ({ session: s, level = 0, onClose }) => {
  useEffect(() => {
    const link = document.createElement("link");
    link.href = "https://fonts.googleapis.com/css2?family=Nunito:wght@400;600;700;800;900&family=Nunito+Sans:wght@400;600&display=swap";
    link.rel = "stylesheet";
    document.head.appendChild(link);
  }, []);

  // Exercices totaux : rounds × exercices par round
  const totalExercises = (s?.rounds || 0) * (s?.totalEx || 0);

  // Calories estimées : ~8 kcal/min pour du HIIT
  const durationMin = s?.duration || 0;
  const caloriesEst = Math.round(durationMin * 8);

  // Date formatée
  const dateStr = s?.date
    ? new Date(s.date).toLocaleDateString("fr-FR", { weekday: "long", day: "numeric", month: "long", year: "numeric" })
    : "";
  const dateFormatted = dateStr.charAt(0).toUpperCase() + dateStr.slice(1);

  const session = {
    name: s?.programName || "TABATA",
    interval: s?.interval || "",
    date: dateFormatted,
    exercises: String(totalExercises),
    duration: `${durationMin}min`,
    calories: String(caloriesEst),
  };

  return (
    <div style={{
      width: 390,
      height: 693,
      overflow: "hidden",
      position: "relative",
      background: "#080808",
      display: "flex",
      flexDirection: "column",
      fontFamily: "'Nunito', sans-serif",
    }}>

      {/* ── NOISE TEXTURE overlay ── */}
      <svg style={{ position: "absolute", width: 0, height: 0 }}>
        <filter id="noise-tabata">
          <feTurbulence type="fractalNoise" baseFrequency="0.75" numOctaves="4" stitchTiles="stitch" />
          <feColorMatrix type="saturate" values="0" />
          <feBlend in="SourceGraphic" mode="overlay" />
        </filter>
      </svg>
      <div style={{
        position: "absolute", inset: 0, zIndex: 0,
        filter: "url(#noise-tabata)",
        opacity: 0.035,
        background: "#fff",
      }} />

      {/* ── FOND gradient raffiné ── */}
      <div style={{
        position: "absolute", inset: 0, zIndex: 0,
        background: `
          radial-gradient(ellipse 60% 35% at 85% 10%, rgba(212,175,55,0.22) 0%, transparent 70%),
          radial-gradient(ellipse 50% 30% at 15% 90%, rgba(180,140,30,0.18) 0%, transparent 65%),
          linear-gradient(175deg, #14110A 0%, #0A0805 40%, #060503 100%)
        `,
      }} />

      {/* ── FILIGRANE géométrique ── */}
      <div style={{
        position: "absolute", top: "50%", left: "50%",
        transform: "translate(-50%, -50%)",
        width: 300, height: 300, zIndex: 0,
        borderRadius: "50%",
        border: "1px solid rgba(212,175,55,0.1)",
        boxShadow: "0 0 0 40px rgba(212,175,55,0.05), 0 0 0 80px rgba(212,175,55,0.03)",
      }} />
      <div style={{
        position: "absolute", top: "50%", left: "50%",
        transform: "translate(-50%, -50%) rotate(45deg)",
        width: 200, height: 200, zIndex: 0,
        border: "1px solid rgba(212,175,55,0.08)",
      }} />

      {/* ── BANDE OR haut ── */}
      <div style={{
        position: "absolute", top: 0, left: 0, right: 0,
        height: 2, zIndex: 2,
        background: "linear-gradient(90deg, transparent 0%, rgba(212,175,55,0.98) 30%, #D4AF37 50%, rgba(212,175,55,0.98) 70%, transparent 100%)",
      }} />

      {/* ── HEADER : LOGO + BEARFORGE ── */}
      <div style={{
        position: "relative", zIndex: 1,
        display: "flex", alignItems: "center", justifyContent: "space-between",
        padding: "28px 28px 0",
      }}>
        <div style={{
          width: 66, height: 66, borderRadius: "50%",
          background: "linear-gradient(135deg, rgba(212,175,55,0.22) 0%, rgba(160,120,20,0.2) 100%)",
          border: "1px solid rgba(212,175,55,0.55)",
          display: "flex", alignItems: "center", justifyContent: "center",
          boxShadow: "0 0 16px rgba(212,175,55,0.22)",
          overflow: "hidden",
        }}>
          <img src={LOGO_LIGHT_DATA} alt="Calestan" style={{ width: 52, height: 52, objectFit: "contain" }} />
        </div>

        <div style={{ textAlign: "right" }}>
          <div style={{
            color: "#D4AF37",
            fontSize: 15, fontWeight: 800,
            letterSpacing: "5px",
            fontFamily: "'Nunito', sans-serif",
            textTransform: "uppercase",
          }}>Calestan</div>
        </div>
      </div>

      {/* ── DIVIDER or ── */}
      <div style={{
        position: "relative", zIndex: 1,
        margin: "20px 28px 0",
        display: "flex", alignItems: "center", gap: 10,
      }}>
        <div style={{ flex: 1, height: 1, background: "linear-gradient(90deg, transparent, rgba(212,175,55,0.6))" }} />
        <div style={{
          width: 5, height: 5,
          background: "#D4AF37",
          transform: "rotate(45deg)",
        }} />
        <div style={{ flex: 1, height: 1, background: "linear-gradient(90deg, rgba(212,175,55,0.6), transparent)" }} />
      </div>

      {/* ── LABEL ── */}
      <div style={{
        position: "relative", zIndex: 1,
        textAlign: "center", marginTop: 20,
      }}>
        <div style={{
          display: "inline-block",
          color: "rgba(212,175,55,0.85)",
          fontSize: 10, letterSpacing: "5px",
          fontFamily: "'Nunito', sans-serif",
          textTransform: "uppercase",
          fontWeight: 600,
          borderBottom: "1px solid rgba(212,175,55,0.4)",
          paddingBottom: 5,
        }}>Séance Tabata</div>
      </div>

      {/* ── NOM SÉANCE ── */}
      <div style={{
        position: "relative", zIndex: 1,
        textAlign: "center",
        padding: "16px 24px 0",
      }}>
        {session.interval ? (
          <div style={{
            color: "rgba(212,175,55,0.9)",
            fontSize: 13, letterSpacing: "6px",
            fontFamily: "'Nunito', sans-serif",
            textTransform: "uppercase",
            fontWeight: 700,
            marginBottom: 6,
          }}>{session.interval}</div>
        ) : null}
        <div style={{
          color: "#FFF0B0",
          fontSize: 36, fontWeight: 900,
          lineHeight: 1.1,
          fontFamily: "'Nunito', sans-serif",
          textTransform: "uppercase",
          letterSpacing: "2px",
          textShadow: "0 0 60px rgba(212,175,55,0.5), 0 2px 20px rgba(0,0,0,0.8)",
          maxWidth: "100%",
          overflow: "hidden",
          display: "-webkit-box",
          WebkitLineClamp: 3,
          WebkitBoxOrient: "vertical",
        }}>{session.name}</div>
        <div style={{
          color: "rgba(212,175,55,0.75)",
          fontSize: 12, marginTop: 10,
          fontFamily: "'Nunito Sans', sans-serif",
          fontStyle: "italic",
          letterSpacing: "0.5px",
          fontWeight: 400,
        }}>{session.date}</div>
      </div>

      {/* ── 3 STATS ── */}
      <div style={{
        position: "relative", zIndex: 1,
        display: "flex",
        margin: "28px 22px 0",
        gap: 1,
      }}>
        {[
          { label: "Exercices", value: session.exercises, sub: "total" },
          { label: "Durée", value: session.duration, sub: "effort" },
          { label: "Calories", value: session.calories, sub: "dépensées" },
        ].map((st, i) => (
          <div key={i} style={{
            flex: 1,
            borderTop: i === 1
              ? "1px solid rgba(212,175,55,0.75)"
              : "1px solid rgba(212,175,55,0.35)",
            borderBottom: i === 1
              ? "1px solid rgba(212,175,55,0.75)"
              : "1px solid rgba(212,175,55,0.35)",
            borderLeft: i === 0 ? "1px solid rgba(212,175,55,0.35)" : "none",
            borderRight: i === 2 ? "1px solid rgba(212,175,55,0.35)" : "none",
            padding: "18px 10px 16px",
            textAlign: "center",
            background: i === 1
              ? "linear-gradient(180deg, rgba(212,175,55,0.14) 0%, rgba(180,148,80,0.04) 100%)"
              : "transparent",
            position: "relative",
          }}>
            {i < 2 && (
              <div style={{
                position: "absolute", right: 0, top: "20%", bottom: "20%",
                width: 1,
                background: "linear-gradient(180deg, transparent, rgba(212,175,55,0.5), transparent)",
              }} />
            )}
            <div style={{
              color: i === 1 ? "#D4AF37" : "#C49A20",
              fontSize: i === 1 ? 25 : 22,
              fontWeight: 900,
              fontFamily: "'Nunito', sans-serif",
              letterSpacing: "1px",
              lineHeight: 1,
            }}>{st.value}</div>
            <div style={{
              color: "rgba(212,175,55,0.78)",
              fontSize: 9, letterSpacing: "2.5px",
              marginTop: 7, textTransform: "uppercase",
              fontFamily: "'Nunito', sans-serif",
              fontWeight: 600,
            }}>{st.label}</div>
          </div>
        ))}
      </div>

      {/* ── BADGE HIIT ── */}
      <div style={{
        position: "relative", zIndex: 1,
        textAlign: "center", marginTop: 22,
      }}>
        <div style={{
          display: "inline-flex", alignItems: "center", gap: 8,
          background: "linear-gradient(135deg, rgba(212,175,55,0.18) 0%, rgba(160,120,20,0.14) 100%)",
          border: "1px solid rgba(212,175,55,0.5)",
          borderRadius: 2, padding: "9px 20px",
          color: "#D4AF37",
          fontSize: 13, letterSpacing: "2px",
          fontFamily: "'Nunito', sans-serif",
          fontWeight: 700,
          textTransform: "uppercase",
        }}>
          <span style={{ fontSize: 13 }}>✦</span>
          <span>Entraînement HIIT accompli</span>
          <span style={{ fontSize: 13 }}>✦</span>
        </div>
      </div>

      {/* SPACER */}
      <div style={{ flex: 1 }} />

      {/* ── FOOTER ── */}
      <div style={{
        position: "relative", zIndex: 1,
        marginTop: 16,
      }}>
        <div style={{
          height: 1,
          background: "linear-gradient(90deg, transparent, rgba(212,175,55,0.5) 30%, rgba(212,175,55,0.5) 70%, transparent)",
        }} />
        <div style={{
          textAlign: "center",
          padding: "12px 0 18px",
          display: "flex", alignItems: "center", justifyContent: "center", gap: 10,
        }}>
          <div style={{ width: 20, height: 1, background: "rgba(212,175,55,0.5)" }} />
          <div style={{
            color: "rgba(212,175,55,0.6)",
            fontSize: 9, letterSpacing: "3.5px",
            fontFamily: "'Nunito', sans-serif",
            textTransform: "uppercase",
            fontWeight: 600,
          }}>calestan.fr</div>
          {level > 0 && <>
            <div style={{ width: 3, height: 3, background: "rgba(212,175,55,0.4)", borderRadius: "50%" }} />
            <div style={{
              color: "rgba(212,175,55,0.6)",
              fontSize: 9, letterSpacing: "3px",
              fontFamily: "'Nunito', sans-serif",
              textTransform: "uppercase",
              fontWeight: 600,
            }}>NIV. {level}</div>
          </>}
          <div style={{ width: 20, height: 1, background: "rgba(212,175,55,0.5)" }} />
        </div>
      </div>

      {/* ── BOUTON RETOUR ── */}
      {onClose && (
        <div onClick={onClose} style={{
          position: "absolute", top: 16, left: 16, zIndex: 10,
          width: 36, height: 36, borderRadius: "50%",
          background: "rgba(0,0,0,0.5)",
          border: "1px solid rgba(212,175,55,0.35)",
          display: "flex", alignItems: "center", justifyContent: "center",
          cursor: "pointer",
        }}>
          <span style={{ color: "#D4AF37", fontSize: 16, lineHeight: 1 }}>←</span>
        </div>
      )}

      {/* ── BANDE OR BAS ── */}
      <div style={{
        position: "absolute", bottom: 0, left: 0, right: 0,
        height: 2, zIndex: 2,
        background: "linear-gradient(90deg, transparent 0%, rgba(212,175,55,0.82) 30%, #D4AF37 50%, rgba(212,175,55,0.82) 70%, transparent 100%)",
      }} />

    </div>
  );
};

export { ShareCardTabata };
export default ShareCardTabata;
